import React, { useState, useEffect } from 'react';
import './styles.css';
// index.js または App.js
import "academicons/css/academicons.min.css";


const LlamaMimiPage = () => {
  return (
    <div className="page">

      {/* Header */}
      <div className="header">
        <h1>
          WAON: Large-Scale and High-Quality Japanese Image-Text Dataset for Vision-Language Models
        </h1>
        <div className="authors">
          <span><a href="#">Issa Sugiura</a><sup>1,2</sup></span>
          <span><a href="#">Shuhei Kurita</a><sup>3,2</sup></span>
          <span><a href="#">Yusuke Oda</a><sup>2</sup></span>
          <span><a href="#">Daisuke Kawahara</a><sup>4,2</sup></span>
          <span><a href="#">Yasuo Okabe</a><sup>1</sup></span>
          <span><a href="#">Naoaki Okazaki</a><sup>5,2</sup></span>
        </div>
        <div className="affiliations">
          <sup>1</sup>Kyoto University, <sup>2</sup>NII LLMC, <sup>3</sup>NII, <sup>4</sup>Waseda University, <sup>5</sup>Institute of Science Tokyo
        </div>
        <div className="links">
                  <a
  href="https://arxiv.org/abs/2510.22276"
  className="btn"
>
  <i className="ai ai-arxiv ai-lg"></i>
  <span>arXiv</span>
          </a>
          <a href="https://huggingface.co/datasets/llm-jp/WAON" className="btn">🤗 WAON</a>
          <a href="https://huggingface.co/datasets/llm-jp/WAON-Bench" className="btn">🤗 WAON-Bench</a>
          <a href="https://huggingface.co/llm-jp/waon-siglip2-base-patch16-256" className="btn">🤗 Model</a>
          <a
  href="https://github.com/llm-jp/WAON"
  className="btn"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ marginRight: "8px" }}
  >
    <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.1 3.29 9.42 7.86 10.96.58.1.79-.25.79-.56
    0-.28-.01-1.02-.02-2-3.2.7-3.88-1.54-3.88-1.54-.53-1.36-1.29-1.72-1.29-1.72-1.05-.72.08-.7.08-.7
    1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.72-1.55-2.55-.29-5.23-1.28-5.23-5.7
    0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.15 1.18A10.9 10.9 0 0112 6.8c.97.01 1.95.13
    2.87.38 2.18-1.49 3.14-1.18 3.14-1.18.62 1.58.24 2.75.12 3.04.73.81 1.18 1.83 1.18 3.09
    0 4.43-2.68 5.41-5.24 5.7.41.36.77 1.08.77 2.18
    0 1.57-.01 2.83-.01 3.21 0 .31.21.67.79.56A10.52 10.52 0 0023.5 12C23.5 5.73 18.27.5 12 .5z"/>
  </svg>
  Code
          </a>
          <a href="https://speed1313.github.io/posts/WAON" className="btn">📝 Blog</a>
        </div>
      </div>

          {/* Abstract */}
      <div className="section">
        <h2 className="section-title">Abstract</h2>
        <div className="prose">
          <p>
            Large-scale and high-quality image-text pair datasets play an important role in developing high-performing Vision-Language Models (VLMs).
In this work, we introduce <strong>WAON</strong>, a large-scale and high-quality Japanese image-text pair dataset containing approximately 155 million examples, collected from Common Crawl.
Our dataset construction pipeline employs various techniques, including filtering and deduplication, which have been shown to be effective in previous studies.
To evaluate its effectiveness, we also construct <strong>WAON-Bench</strong>, a manually curated benchmark for Japanese cultural image classification, consisting of 374 classes.
To assess the effectiveness of our dataset, we conduct experiments using both WAON and the Japanese subset of ReLAION, one of the most widely used vision-language datasets. We fine-tune SigLIP2, a strong multilingual model, on both datasets. The results demonstrate that WAON enhances model performance on WAON-Bench more efficiently than ReLAION and achieves higher accuracy across across all evaluated benchmarks. Furthermore, the model fine-tuned on WAON achieves state-of-the-art performance on several Japanese cultural benchmarks.
We release our dataset, model, and code to promote reproducibility and advance the development of VLMs.
          </p>
        </div>
      </div>


          {/* Teaser - Scrollable Results */}
      <div className="section bg-gray">
        <h2 className="section-title">Figures</h2>
        <div className="scrollable-container">
          <div className="scroll-content">
            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/validation_top1_accuracy.svg`} alt="WAON-Bench Top-1 Accuracy" />
              </div>
              <p className="result-caption">
                <strong>WAON-Bench Top-1 accuracy over training.</strong> Fine-tuning <code>google/siglip2-base-patch16-256</code> on WAON improves performance on Japanese cultural benchmarks more efficiently than fine-tuning on the ReLAION (Japanese subset).
              </p>
            </div>

            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/WAON-Bench.jpg`} alt="ImageNet-ja Accuracy" />
              </div>
              <p className="result-caption">
                <strong>Overview of WAON-Bench.</strong> WAON-Bench consists of 8 categories with a total of 374 classes, each containing 5 images, resulting in a total of 1,870 images.
              </p>
            </div>

            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/waon-pipeline.svg`} alt="WAON-Bench Top-5 Accuracy" />
              </div>
              <p className="result-caption">
                <strong>Construction pipeline of WAON.</strong> The numbers in parentheses indicate the remaining data count after each processing step (based on the 2025-18 snapshot).
              </p>
            </div>
          </div>
          <div className="scroll-indicator">
            <span>← Scroll for more results →</span>
          </div>
        </div>
      </div>



 {/* Results Table */}
      <div className="section">
        <h2 className="section-title">Evaluation Results</h2>
        <div className="table-container">
          <table className="results-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>Params</th>
                <th colSpan="1">Retrieval</th>
                <th colSpan="3">Image Classification</th>
                <th>Avg</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th>XM3600<sub>ja</sub></th>
                <th>ImageNet<sub>ja</sub></th>
                <th>Recruit</th>
                <th>WAON-Bench</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr className="highlight-row">
                <td><a href="https://huggingface.co/llm-jp/waon-siglip2-base-patch16-256">siglip2-base-patch16-256 (fine-tuned on WAON)</a></td>
                <td>375M</td>
                <td>73.75</td>
                <td>49.61</td>
                <td><strong>83.14</strong></td>
                <td><strong>94.97</strong></td>
                <td><strong>75.37</strong></td>
              </tr>
              <tr>
                <td>siglip2-base-patch16-256 (fine-tuned on ReLAION)</td>
                <td>375M</td>
                <td>72.39</td>
                <td>47.38</td>
                <td>81.65</td>
                <td>92.99</td>
                <td>73.60</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/google/siglip2-base-patch16-256">google/siglip2-base-patch16-256</a></td>
                <td>375M</td>
                <td>38.28</td>
                <td>48.12</td>
                <td>76.98</td>
                <td>87.81</td>
                <td>62.80</td>
              </tr>
              <tr className="separator-row">
                <td colSpan="7"></td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/line-corporation/clip-japanese-base">clip-japanese-base</a></td>
                <td>196M</td>
                <td><strong>78.00</strong></td>
                <td>48.90</td>
                <td>81.65</td>
                <td>90.05</td>
                <td>74.65</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/google/siglip-base-patch16-256-multilingual">siglip-base-patch16-256-mult</a></td>
                <td>371M</td>
                <td>43.22</td>
                <td>53.26</td>
                <td>75.10</td>
                <td>89.25</td>
                <td>65.21</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/stabilityai/japanese-stable-clip-vit-l-16">Japanese Stable CLIP ViT-L-16</a></td>
                <td>414M</td>
                <td>66.03</td>
                <td><strong>55.97</strong></td>
                <td>71.29</td>
                <td>82.03</td>
                <td>68.83</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/laion/CLIP-ViT-H-14-frozen-xlm-roberta-large-laion5B-s13B-b90k">LAION-CLIP-ViT-H-14</a></td>
                <td>1193M</td>
                <td>72.64</td>
                <td>47.67</td>
                <td>70.62</td>
                <td>85.88</td>
                <td>69.20</td>
              </tr>
            </tbody>
          </table>
          <p className="table-caption">
            Performance of models on each dataset. Fine-tuning <a href="https://huggingface.co/google/siglip2-base-patch16-256">google/siglip2-base-patch16-256</a> on the WAON dataset achieves state-of-the-art performance on the Japanese cultural benchmarks, Recruit and WAON-Bench. Using WAON consistently yields higher performance across all benchmark datasets compared to fine-tuning on ReLAION (ja subset).
          </p>
        </div>
      </div>

      {/* BibTeX */}
      <div className="section bg-gray">
        <div className="bibtex-header">
          <h2 className="section-title">BibTeX</h2>
          <button
            className="btn"
            onClick={() => {
              const bibtex = `@misc{sugiura2025waonlargescalehighqualityjapanese,
      title={WAON: Large-Scale and High-Quality Japanese Image-Text Pair Dataset for Vision-Language Models},
      author={Issa Sugiura and Shuhei Kurita and Yusuke Oda and Daisuke Kawahara and Yasuo Okabe and Naoaki Okazaki},
      year={2025},
      eprint={2510.22276},
      archivePrefix={arXiv},
      primaryClass={cs.CV},
      url={https://arxiv.org/abs/2510.22276},
}`;
              navigator.clipboard.writeText(bibtex);
              alert('BibTeX copied to clipboard!');
            }}
          >
            📋 Copy
          </button>
        </div>
        <pre className="bibtex-code">
{`@misc{sugiura2025waonlargescalehighqualityjapanese,
      title={WAON: Large-Scale and High-Quality Japanese Image-Text Pair Dataset for Vision-Language Models},
      author={Issa Sugiura and Shuhei Kurita and Yusuke Oda and Daisuke Kawahara and Yasuo Okabe and Naoaki Okazaki},
      year={2025},
      eprint={2510.22276},
      archivePrefix={arXiv},
      primaryClass={cs.CV},
      url={https://arxiv.org/abs/2510.22276},
}`}
        </pre>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>
          This page was built using the <a href="https://github.com/eliahuhorwitz/Academic-project-page-template">Academic Project Page Template</a>...<br />
          This website is licensed under a <a href="http://creativecommons.org/licenses/by-sa/4.0/">CC BY-SA 4.0</a>.
        </p>
      </footer>
    </div>
  );
};

export default LlamaMimiPage;
